export default function DSA_Study_Plan() {
  return <div>DSA_Study_Plan Component</div>;
}
